import {
  Component,
  OnInit,
  AfterViewChecked,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {RightSideDrawerService} from '../right-side-drawer.service';
import {SessionService} from '../../session-service/session.service';
import {DefineActivitiesService} from '../../../data-analysis-summary/define-activities/define-activities.service';
import {FormGroup, FormControl} from '@angular/forms';
import {Comments} from '../../models/commemnts.model';
import {SurveyDetailsService} from 'src/app/survey/survey-details/survey-details.service';
import {ToastrService} from '@kpmg-tax/ui';
import {Messages} from '../../constants/messages';
import {formatDate} from '@angular/common';
import {API_URL} from '../../constants/apiurl-constants';
import {ReconcilationDetailsService} from '../../../survey/reconcilation-details/reconcilation-details.service';
import { encodeText, decodeText } from 'src/app/shared/lib/custom-tools';

@Component({
  selector: 'comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent implements OnInit, AfterViewChecked {
  targetForm: FormGroup;
  surveyId: number;
  employeeId: number;
  comment: Comments;
  comments: Comments;
  resolvedStatus: boolean = false;
  engagementId: number;
  isReconcile: boolean = false;
  isDisabled: boolean = false;
  isArchived: boolean = false;

  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    public activitiesService: DefineActivitiesService,
    public sessionService: SessionService,
    public surveyDetailsServeice: SurveyDetailsService,
    public toastrService: ToastrService,
    private _reconcilationDetailsService: ReconcilationDetailsService,
  ) {
    this.engagementId = Number(this.sessionService.getSession('engagementId'));
  }

  public resetRightSideDrawerData = () => {
    this.targetForm.reset();
  }

  ngOnInit() {
    this.isArchived = this.sessionService.getSession('isArchived') === 'true';
    this.targetForm = new FormGroup({
      comment: new FormControl(''),
    });

    this.resetRightSideDrawerData();
    this.surveyId = this.surveyDetailsServeice.getSurveyId();
    this.employeeId = this.surveyDetailsServeice.getEmployeeId();
    this.resolvedStatus = this.surveyDetailsServeice.getResolveStatus();

    if (this.rightSideDrawerService.singleRowAddData !== 'RECONCILE') {
      if (this.surveyId && this.employeeId) {
        this.getComments();
      }
    } else {
      this.isReconcile = true;
      this.getReconcileComments();
    }

    let today = new Date();
    let date = formatDate(today, 'short', 'en-US');
  }

  trimSpecialChar(ctrl: any) {   
    if(this.targetForm.controls[ctrl].value!== null)
    {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
    );
    }
  }

  ngAfterViewChecked() {
    //if (this.rightSideDrawerService.triggerRightSideDrawerClick) {
    //  this.rightSideDrawerService.triggerRightSideDrawerClick = false; // Set trigger to false so that this action is only performed once. Without this, the form would keep resetting on every change on any input.
    //  this.resetRightSideDrawerData();
    //}
  }

  getComments() {
    this.sessionService
      .apiUrlGet(
        API_URL.COMMENTS.GETCOMMENTS +
          '?surveyId=' +
          this.surveyId +
          '&employeeId=' +
          this.employeeId +
          '&engagementId=' +
          this.surveyDetailsServeice.getEngagementId(),
      )
      .subscribe((data: any) => {
        this.comments = data.result;
      });
  }

  getReconcileComments() {
    this.sessionService
      .apiUrlGet(
        API_URL.COMMENTS.GETRECONCILECOMMENTS +
          '?engagementId=' +
          this.engagementId +
          '&employeeId=' +
          this.employeeId,
      )
      .subscribe((data: any) => {
        this.comments = data.result;
        data.result.forEach(element => {
          this.resolvedStatus = element.resolved;
        });
      });
  }

  addComment = () => {
    this.isDisabled = true;
    let comment: Comments = {
      surveyId: !this.isReconcile
        ? this.surveyDetailsServeice.getSurveyId()
        : null,
      employeeId: this.surveyDetailsServeice.getEmployeeId(),
      comments: encodeText(this.targetForm.get('comment').value),
      resolved: true,
      engagementId: this.engagementId,
    };

    this.sessionService
      .apiUrlPost(API_URL.COMMENTS.ADDCOMMENTS, comment)
      .subscribe((data: any) => {
        if (data.success) {
          this.toastrService.setSuccessMessage(
            Messages.AddSurveyEmployeeCommentsSucess,
          );
          if (!this.isReconcile) {
            this.getComments();
            this.resetRightSideDrawerData();
            this.surveyDetailsServeice.loadSurveyDetails(this.surveyId);
          } else {
            this.getReconcileComments();
            this._reconcilationDetailsService.Row['fileCount'].comment = true;
            this.resetRightSideDrawerData();
            }
            this.closeDrawer();
        } else {
          this.isDisabled = false;
          this.toastrService.setErrorMessage(Messages.Comments.AddFailure);
        }
      });
  }

  closeDrawer = () => {
    this.resetRightSideDrawerData();
    this.rightSideDrawerService.closeRightSideDrawer();
  }

  resolveComment() {
    this.isDisabled = true;
    this.employeeId = this.surveyDetailsServeice.getEmployeeId();
    if (!this.isReconcile) {
      this.surveyId = this.surveyDetailsServeice.getSurveyId();
      this.surveyDetailsServeice
        .resolveComment(this.surveyId, this.employeeId)
        .subscribe((result: any) => {
          if (result.result) {
            this.toastrService.setSuccessMessage(
              Messages.Comments.ResolveSuccess,
            );
            this.closeDrawer();
            this.surveyDetailsServeice.loadSurveyDetails(this.surveyId);
          } else {
            this.toastrService.setErrorMessage(Messages.Comments.ResolveFailure);
          }
        });
    } else {
      this.isDisabled = false;
      let resolveComment: any = {
        employeeId: this.employeeId,
        engagementId: this.engagementId,
        resolved: false,
      };
      this.sessionService
        .apiUrlPost(API_URL.COMMENTS.RESOLVERECONCILECOMMENT, resolveComment)
        .subscribe((data: any) => {
          if (data.result) {
            this._reconcilationDetailsService.Row['fileCount'].comment = false;
            this.toastrService.setSuccessMessage(
              Messages.Comments.ResolveSuccess,
            );
            this.closeDrawer();
          } else {
            this.isDisabled = false;
            this.toastrService.setErrorMessage(Messages.Comments.ResolveFailure);
          }
        });
    }
  }

  onAddComment() {
    if (this.targetForm.get('comment').value !== '') {
      this.rightSideDrawerService.setMandatoryField(true, 'Comments');
    } else {
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }
}
